import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Sociedades';

export interface Sociedad {
  idSociedad: string;
	sociedad: string;
	codPais: string;
	pais: string;
	fechaBaja: string;
}

export interface SociedadOriginal {
	idSociedadOriginal: string;
	sociedadOriginal: string;
}

export interface SociedadUser {
	idSociedad: string;
	sociedad: string;
	codPais: string;
	pais: string;
	fechaBaja: string;
  }

export class SociedadesAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarSociedades(dni?:string): AxiosPromise<Sociedad[]> {
		return this.cliente.post({dni:dni},`/ListarSociedades`);
	}

	ListarSociedadesActivas(): AxiosPromise<Sociedad[]> {
		return this.cliente.get(`/ListarSociedadesActivas`);
	}

	ListarSociedadesAdministradorExpatriados(rol:string): AxiosPromise<Sociedad[]> {
		return this.cliente.get(`/ListarSociedadesAdministradorExpatriados/${rol}`);
	}

	ListarSociedadesExpatriados(filtrarRoles:number): AxiosPromise<Sociedad[]> {
		return this.cliente.get(`/ListarSociedadesExpatriados/${filtrarRoles}`);
	}

	ListarSociedadesOriginales(): AxiosPromise<SociedadOriginal[]> {
		return this.cliente.get(`/ListarSociedadesOriginales`);
	}

	CrearSociedad(sociedad: any): AxiosPromise<Sociedad[]> {
		return this.cliente.post(sociedad, `/CrearSociedad`);
	}
	
	EliminarSociedad(id: string): AxiosPromise<any> {
		return this.cliente.remove(id, `/EliminarSociedad`);
	}

	ModificarSociedad(idActual:string,sociedad: any): AxiosPromise<any[]> {
		return this.cliente.put(idActual, sociedad, `/ModificarSociedad`);
	}
}